import * as diff from 'diff';

/**
 * A word-level diff of two values, marked up the way the product already writes
 * a change: what went in `<ins>`, what came out in `<del>`.
 *
 * Lifted verbatim out of track.js, where the audit log has rendered every
 * before/after this way — "Display Name: <del>Acme</del><ins>Acme Holdings</ins>"
 * — across fifteen call sites. Moved here rather than copied so the playbook's
 * stale-draft comparison says a change the same way the audit log does, and so
 * there is one place to fix when the marks or the granularity change.
 *
 * NOT SAFE TO BIND UNSANITISED. `part.value` is interpolated into markup with no
 * escaping, so a value carrying angle brackets reaches the DOM as elements. That
 * is inherited behaviour and its existing callers pass audit metadata, but any
 * new caller handling text a customer typed must run the result through
 * safeSanitize with `ins` and `del` on the allow-list.
 */
export const getDiffText = (before, after) => {
  if (!before) {
    before = '';
  }

  if (typeof before !== 'string') {
    before = before.toString();
  }

  if (!after) {
    after = '';
  }

  if (typeof after !== 'string') {
    after = after.toString();
  }

  const differences = diff.diffWords(before, after, { ignoreCase: false });

  return differences
    .map(part => {
      if (part.added) {
        return `<ins>${part.value}</ins>`;
      } else if (part.removed) {
        return `<del>${part.value}</del>`;
      }
      return part.value;
    })
    .join('');
};
